import React from "react";
import {
  TextField
} from  "@material-ui/core";
import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import { alpha } from '@material-ui/core';
import { isNumeric, isInteger } from "../../_helpers/functions.fieldValue";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root input": {
      height: "25px",
      paddingTop: "3px",
      paddingBottom: "3px",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    '&:hover .MuiOutlinedInput-root:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
      borderColor: props => props.textColor ? alpha(props.textColor, 0.4) : theme.palette.color.secondary.main,
      borderStyle: 'dotted'
    },
    "& .MuiOutlinedInput-root.Mui-focused  .MuiOutlinedInput-notchedOutline": {
      borderColor: props => props.textColor ? alpha(props.textColor, 0.6) : theme.palette.color.primary.main,
      borderWidth: 1
    },
  }
}));

export const GhostTextField = (props) => {
  const {
    value, // value is a number
    intOnly = false, 
    maximumFractionDigits = 4,
    onChange, 
    textAlign = 'center', 
    width = "auto", 
    marginLeft, 
    marginRight, 
    paddingRight, 
    fontSize, 
    textColor,
    fontWeight,
     ...other} = props;

  const classes = useStyles({textColor: textColor});

  const numToViewString = (num) => {
    return num.toLocaleString("en-US",{maximumFractionDigits : maximumFractionDigits, useGrouping: "auto"});
  };
  
  const numToEditString = (num) => {
    return num.toLocaleString("en-US",{maximumFractionDigits : maximumFractionDigits, useGrouping: false});
  };

  const [internalValue, setInternalValue] = useState(numToViewString(value));

  useEffect(() => {
    setInternalValue(numToViewString(value));
  }, [value]);

  return (
    <TextField
      {...other} 
      autoComplete="off"
      margin="dense"
      size="small"
      type="text"
      variant="outlined"
      value={internalValue}
      style={{
        width: width,
        flexGrow: 0,
        marginLeft: marginLeft,
        marginRight: marginRight,
        fontWeight: fontWeight,
      }}
      inputProps={{style: {
        textAlign: textAlign,
        paddingRight: paddingRight,
        fontSize: fontSize,
        color: textColor,
        fontWeight: fontWeight,
      }}}
      onChange={(e) => {
        if (intOnly) {
          const regex = /^[0-9\b]+$/;
          if (e.target.value === "" || regex.test(e.target.value)) {
            setInternalValue(e.target.value);
          }
        } else {
          setInternalValue(e.target.value);
        }
      }}
      onFocus={() => {
        setInternalValue(numToEditString(value));
      }}
      onBlur={() => {
        // If the entered value is not a number, forget it and show the original value.
        if ((intOnly && isInteger(internalValue)) || (!intOnly && isNumeric(internalValue))) {
          if (value !== Number(internalValue)) {
            if (onChange) {
              onChange(Number(internalValue));
            }
          } else {
            setInternalValue(numToViewString(value));  
          }
        } else {
          setInternalValue(numToViewString(value));
        }
      }}
      classes={{
        root: classes.root
      }}
    />
  );
};

export default GhostTextField;